import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  state: {
    app_form_token: localStorage.getItem('app_form_token') || null,
    applicant_id: localStorage.getItem('applicant_id') || null,
  },
  mutations: {
    UPDATE_APP_FORM_TOKEN(state, { token }) {
      state.app_form_token = token
    },
    UPDATE_APPLICANT_ID(state, { id }) {
      state.applicant_id = id
    },
  },
  actions: {

  },
  getters: {
    app_form_token: state => state.app_form_token,
    applicant_id: state => state.applicant_id,
  },
}
